import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export type HeaderTheme = 'dark' | 'light';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css'
})
export class HeaderComponent {
    @Input() theme: HeaderTheme = 'dark';
    @Output() themeChange = new EventEmitter<HeaderTheme>();

    get headerLogoSrc(): string {
        return this.theme === 'light'
            ? '/assets/logos/header-light.png'
            : '/assets/logos/header-dark.png';
    }

    onThemeChange(theme: HeaderTheme): void {
        this.themeChange.emit(theme);
    }
}
